import { render } from "./BrandTag.vue?vue&type=template&id=015154e1&scoped=true"
import script from "./BrandTag.vue?vue&type=script&lang=js"
export * from "./BrandTag.vue?vue&type=script&lang=js"

import "./BrandTag.vue?vue&type=style&index=0&id=015154e1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015154e1"]])

export default __exports__